{
  "SidebarMenu_Reporting_Reporting": "Reporting",
  "SidebarMenu_Reporting_Insights": "Insights",
  "SidebarMenu_Reporting_Presence": "Presence",
  "SidebarMenu_FastProvisioning_EnterpriseManagement": "Add Enterprise Company +",
  "SidebarMenu_FastProvisioning_UserManagement": "User Management",
  "SidebarMenu_FastProvisioning_QueueManagement": "Queue Management",
  "SidebarMenu_Admin_Devices": "Devices",
  "SidebarMenu_Admin_Agents": "Agents",
  "SidebarMenu_Admin_ClientConfig": "Client Configuration",
  "SidebarMenu_Admin_Directory": "Directory",
  "SidebarMenu_Admin_Codes": "Codes",
  "SidebarMenu_Admin_Partitions": "Partitions",
  "SidebarMenu_Admin_TelephonyServers": "Telephony Servers",
  "SidebarMenu_Admin_CME": "CME",
  "SidebarMenu_Admin_AppUsers": "Users",
  "SidebarMenu_Admin_CRM_Configuration": "CRM Integration",
  "SidebarMenu_Admin_Recording": "Recording",
  "SidebarMenu_Admin_Messages": "Messages",
  "SidebarMenu_Admin_Database": "Database",
  "SidebarMenu_StatusTools_Licences": "Licences",
  "SidebarMenu_StatusTools_Logging": "Logging",
  "SidebarMenu_StatusTools_LogManagement": "Log Management",
  "SidebarMenu_StatusTools_AuditTrail": "Audit Trail",
  "SidebarMenu_StatusTools_TelephoneModuleStatus": "TelSys Module Status",
  "SidebarMenu_StatusTools_CallControl": "Call Control",
  "SidebarMenu_StatusTools_ServerStatus": "Server Status",
  "NAME": "SidebarMenu"
}